import React, { useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { NetworkRequestState } from 'c-data-layer';
import type { TranslationPath } from 'c-translation';
import { useCommonTranslation } from 'c-translation';
import MetaLayout from 'c-wrapper/Components/MetaLayout/MetaLayout';
import PreAuthLayout from 'c-wrapper/Components/PreAuthLayout/PreAuthLayout';
import { FlashMessage } from 'c-components';
import { passwordResetSelectors, passwordResetThunks } from '../Slices';
import RequestPasswordResetForm from '../Components/RequestPasswordResetForm';

const RequestPasswordResetPage = () => {
    const dispatch = useDispatch();
    const reqState = useSelector(passwordResetSelectors.passwordResetEmailRequestState);
    const reqStateError = useSelector(passwordResetSelectors.passwordResetEmailRequestError);
    const errorMessage = useCommonTranslation(reqStateError as TranslationPath);
    const successMessage = useCommonTranslation('Pages.ForgotPasswordCode.resetEmailSuccess');

    const flashMessage = useMemo(() => {
        if (reqState === NetworkRequestState.Error) {
            return <FlashMessage status="error">{errorMessage}</FlashMessage>;
        }
        if (reqState === NetworkRequestState.Success) {
            return <FlashMessage status="success">{successMessage}</FlashMessage>;
        }

        return null;
    }, [reqState, errorMessage, successMessage]);

    useEffect(
        () => () => {
            dispatch(passwordResetThunks.resetRequestResetEmail());
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    return (
        <MetaLayout metaTitle="Pages.ForgotPasswordRequest.metaTitle">
            <PreAuthLayout
                flashMessage={flashMessage}
                title={useCommonTranslation('Pages.ForgotPasswordRequest.title')}
                subtitle={useCommonTranslation('Pages.ForgotPasswordRequest.subTitle')}
            >
                <RequestPasswordResetForm />
            </PreAuthLayout>
        </MetaLayout>
    );
};

export default RequestPasswordResetPage;
